import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { formatDate } from "utils/Utils";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import FindStructureData from "helper/FindStructureType";
import ToastModal from "views/components/ToastModal";
import { branchData } from "assets/properties/properties";
import { toastAction } from "assets/properties/properties";
import { sortByString } from "utils/Utils";

const Branches = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteBranchId, setDeleteBranchId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [structureTypeData, setStructureTypeData]= useState([]);
  const [callInProgress, setCallInProgress] = useState(false);
  const dispatch = useDispatch();
  // submit create function
  const handlecreatebranchSubmit = () => {
    navigate(branchData?.mainUrl);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  // get api calling


  useEffect(()=>{
      FindStructureData(apiHandler,endpoint,authToken, setStructureTypeData)

  },[])

  useEffect(() => {
    if(structureTypeData.length){
    getHierarchyBranchData();
    }
  }, [structureTypeData.length]);

  const getHierarchyBranchData = async () => {
    let branchList = [];
      let branchCodes = structureTypeData.filter((b) => b.branchType === true);
      if (branchCodes.length > 0) {
        branchCodes.forEach(async (branch) => {
          setCallInProgress(true);
          const result = await apiHandler({
            url: endpoint.MASTER_HIERARCHY_FIND_BY_TYPE_CODE + branch.code,
            authToken: authToken,
          });
          setCallInProgress(false);
          if (result?.data?.error_code) {
            toastUpdate("Error", result?.data?.user_description, true);
          } else {
            branchList = [...branchList, ...result?.data];
          }
          setRawData(branchList);
          const sortedArray = sortByString(branchList, 'name', true);
          parseIndicatorData(sortedArray);
        });
      } else {
        toastUpdate(toastAction?.error,  branchData?.noExist, true);
      }
  };
  // parseindicatordata function
  const parseIndicatorData = (data) => {
    let reportData = [];
    data &&
      data.forEach((branch, index) => {
        let row = {
          viewCode:branch.code,
          branchcode: branch.code,
          branchname: branch.name,
          branchtype:
            branch.branchType === "HEAD_OFFICE" ? "Head Office" : "Branch",
          phone: branch.phoneNumber,
          address: branch.address,
          state: branch.state,
          city: branch.city,
          pincode: branch.pincode,
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
    // view function
    const onClickViewData = (code, type)=>{
      navigate(branchData?.viewUrl + code );
    }
  // icons function
  const getIcons = (code, type) => {
    return (
      <>
        <IconButton
          aria-label="Edit Branch"
          onClick={() => onClickUpdateData(code)}
        >
          <EditIcon />
        </IconButton>
        {type !== "HEAD_OFFICE" && (
          <IconButton
            aria-label="Delete Branch"
            onClick={() => onClickDeleteData(code)}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </>
    );
  };
  // update function
  const onClickUpdateData = (code) => {
    navigate(branchData?.mainUrl + code);
  };

  // delete function
  const onClickDeleteData = (code) => {
    setConfirmationModalHeader(branchData?.delConfirmationHeader);
    setConfirmationModalMsg(branchData?.delConfirmation);
    setDeleteBranchId(code);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteBranchId("");
  };
  const handlePositiveResponse = async () => {
    const branchid = deleteBranchId;
    handleNegativeResponse();
    // Call API to delete Branch
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_DELETE + branchid,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate(toastAction?.error, res?.data?.user_description, true);
    } else {
      toastUpdate(toastAction?.success, branchData?.delBranchSuccess, true);
      getHierarchyBranchData();
    }
  };

  // serach function
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      const createDate = formatDate(row.createdDate);
      const updatedDate = formatDate(row.updatedDate);
      return (
        row.address.toLowerCase().includes(val.toLowerCase()) ||
        row.name.toLowerCase().includes(val.toLowerCase()) ||
        row.masterTypeCode.toLowerCase().includes(val.toLowerCase()) ||
        row.phoneNumber.toLowerCase().includes(val.toLowerCase()) ||
        row.pincode.toLowerCase().includes(val.toLowerCase()) ||
        row.state.toLowerCase().includes(val.toLowerCase()) ||
        row.city.toLowerCase().includes(val.toLowerCase())
      );
    });
    
    parseIndicatorData(filteredData);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label={branchData?.label}
          onSearchChange={onSearchChange}
          searchLabel = {branchData?.searchLabel}
          search
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
            <ColumnGroupingTable columns={branchData?.tableColumns} rows={selectedTableData} onClickViewData={onClickViewData}    clickable  />
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

Branches.propTypes = {
  classes: PropTypes.object,
};

export default Branches;
